import Price from '~/utils/Price/Price';

export default function calculateComparativePrice(price: Price, packageSize: number, dosageStrength: number): Price {
	const value = Number(price.value) / (packageSize * dosageStrength);
	return new Price(String(value), price.currency);
}
